import { haversineDistance } from "core/utils/haversineDistance";
import type { AnonymousPublicShopDto } from "features/EstimateRequest/entities";

/**
 * Calculates the distance between a shop and a given position in meters.
 */
export function getDistanceToShopInMeters(
  shop: AnonymousPublicShopDto,
  position: GeolocationPosition | null
): number | null {
  if (!position) {
    return null;
  }
  const longFloat = shop.longitude;
  const latFloat = shop.latitude;
  if (!longFloat || !latFloat) {
    return null;
  }
  const distanceInMeters = haversineDistance(position?.coords, {
    latitude: latFloat,
    longitude: longFloat,
  });
  return distanceInMeters;
}
